//    effect-fade     //
function fadeAnime(){

  // ふわっ
  $('.fadeUpTrigger').each(function(){ //fadeUpTriggerというクラス名が
    var elemPos = $(this).offset().top+30;//要素より、1px下の
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight){
    $(this).addClass('fadeUp');// 画面内に入ったらfadeUpというクラス名を追記
        $(this).css('opacity', '1'); // フェードインする前に透明度を設定
    }else{
    $(this).removeClass('fadeUp');// 画面外に出たらfadeUpというクラス名を外す
        $(this).css('opacity', '0'); // フェードインする前に透明度を設定
    }
    });

}

// 画面をスクロールをしたら動かしたい場合の記述
jQuery(function(){
	jQuery(window).scroll(function (){
	fadeAnime();
	});
	fadeAnime();
});


// フェードイン
function fadeInAnime(){

  // ふわっ
  $('.fadeInTrigger').each(function(){ //fadeUpTriggerというクラス名が
    var elemPos = $(this).offset().top+30;//要素より、50px上の
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight){
      $(this).addClass('fadeIn');// 画面内に入ったらfadeUpというクラス名を追記
      $(this).css('opacity', '1'); // フェードインする前に透明度を設定
    } else {
      $(this).removeClass('fadeIn');// 画面外に出たらfadeUpというクラス名を外す
      $(this).css('opacity', '0'); // 画面外に出たら透明にする
    }
  });
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function (){
  fadeInAnime();/* アニメーション用の関数を呼ぶ*/
});

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function(){
  fadeInAnime();/* アニメーション用の関数を呼ぶ*/
});



// アニメーションを適用する要素を取得
const elementsToAnimate = document.querySelectorAll('.animate-up');

// IntersectionObserver のコールバック関数
const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    // 要素が画面に入ったとき
    if (entry.isIntersecting) {
      entry.target.classList.add('show'); // アニメーションを開始
    } else {
      entry.target.classList.remove('show'); // 画面外に出たときにアニメーションをリセット
    }
  });
}, {
  threshold: 0.01 // 要素が画面の10%見えた時に発火
});

// 各要素に対してObserverを設定
elementsToAnimate.forEach(element => {
  observer.observe(element); // それぞれの要素を監視
});

function lineAnime() {
  $('.item03-b').each(function() {
    var elemPos = $(this).offset().top + 50; // 要素の位置（少し余裕）
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();

    if (scroll >= elemPos - windowHeight) {
      // 画面に入ったときにクラスを追加
      $(this).addClass('line-active');
    } else {
      // 画面外に出たらクラスを外してリセット
      $(this).removeClass('line-active');
    }
  });
}

// スクロールとロード時に実行
$(window).scroll(function() {
  lineAnime();
});
$(window).on('load', function() {
  lineAnime();
});

function lineAnimeRightToLeft() {
  $('.item03-d').each(function() {
    var elemPos = $(this).offset().top + 150; // 要素の位置（少し余裕）
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();

    if (scroll >= elemPos - windowHeight) {
      // 画面に入ったときにクラスを追加
      $(this).addClass('line-active');
    } else {
      // 画面外に出たらクラスを外してリセット
      $(this).removeClass('line-active');
    }
  });
}

// スクロールとロード時に実行
$(window).scroll(function() {
  lineAnimeRightToLeft();
});
$(window).on('load', function() {
  lineAnimeRightToLeft();
});

// ================================
// item04-a / item04-d の線アニメーション
// ================================
function lineAnime04() {
  $('.item04-a, .item04-d').each(function() {
    var elemPos = $(this).offset().top + 250;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();

    if (scroll >= elemPos - windowHeight) {
      $(this).addClass('line-active');
    } else {
      $(this).removeClass('line-active');
    }
  });
}

// スクロール・ロード時に実行（既存と同じ形式）
$(window).on('scroll', function() {
  lineAnime04();
});
$(window).on('load', function() {
  lineAnime04();
});


window.addEventListener('scroll', function() {
  const bbs = document.querySelector('.bbs');
  if (window.scrollY > 50) { // 50px以上スクロールしたら非表示
    bbs.classList.add('hide');
  } else {
    bbs.classList.remove('hide');
  }
});
